export default __webpack_public_path__ + "static/inst_2-5c91c9f6bced250e1a41179eec526c58.jpg";